import { useContext } from 'react';
import { AskMooContext } from '../context/AskMooProvider';
import type { AskMooContextValue } from '../context/AskMooProvider';

export function useAskMoo(): AskMooContextValue {
  const context = useContext(AskMooContext);
  if (!context) {
    throw new Error('useAskMoo must be used within an AskMooProvider');
  }
  return context;
}
